module.exports = __webpack_public_path__ + "static/subscribers-email-light-c504d8b80930c2d3b3bcb5332c507ec8.png";